import appUniversal from "../../views/appUniversal.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "universal";
  const params = ["page", "limit", "query"];

  $stateProvider.state("universal", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appUniversal,
      },
    },
    reloadOnSearch: false,
    data: { title: "Universal Search" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/universal/universal.urls.js